export default class GetTipoAsistencia {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    try {
      const result = await this.#repository.getTipoAsistencia()
      return result
    } catch (error) {
      console.error('Error al obtener los tipos de asistencia:', error)
      throw error
    }
  }
}
